import React from 'react';
import { motion } from 'framer-motion';
const features = [{
  title: 'Gourmet Stone Kitchen',
  description: 'Entertain effortlessly with sweeping stone benchtops, premium European appliances, and a layout that flows seamlessly into the living spaces. A true culinary centrepiece.'
}, {
  title: 'Family-Friendly Court',
  description: 'Nestled in a whisper-quiet court, offering a safe haven for children to play. The generous 650m² north-facing block provides abundant sunlight and space to grow.'
}, {
  title: 'Modern Comfort & Security',
  description: 'Enjoy year-round comfort with zoned ducted heating and cooling. Complete with double glazing, contemporary finishes, and a comprehensive security system for peace of mind.'
}];
export function Features() {
  return <section className="w-full bg-cream py-20 md:py-28 px-6" data-id="element-40">
      <div className="max-w-6xl mx-auto" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="grid grid-cols-1 md:grid-cols-3 divide-y divide-charcoal/10 md:divide-y-0 md:divide-x md:divide-charcoal/10" data-id="element-42">
          {features.map((feature, index) => <div key={index} className="py-10 md:py-0 md:px-12 first:pt-0 first:md:pl-0 last:pb-0 last:md:pr-0 flex flex-col" data-id="element-43">
              <h3 className="font-display text-xl md:text-2xl mb-4 tracking-wide text-charcoal leading-tight" data-id="element-44">
                {feature.title}
              </h3>

              <p className="text-ink-soft leading-[1.75] font-serif text-base md:text-[17px]" data-id="element-45">
                {feature.description}
              </p>
            </div>)}
        </motion.div>
      </div>
    </section>;
}